import React from "react";
import "./Soluciones.css";

const Card = (props) => {
    console.log(props);
  return (
      <div className="soluciones__cards--1">
        <div className="soluciones__cards--image"><img src={props.imagen} alt="" className="soluciones__cards--image1"/></div>
        <div className="soluciones__cards--2">
            <div className="soluciones__cards--title">{props.titulo}</div>
            <div className="soluciones__cards--text">{props.contenido}</div>
        </div>
        
      </div>
  );
};

export default Card;
